import { useCallback, useState } from "react";
import useResizeObserver from "@react-hook/resize-observer";
const useNaturalWidth = () => {
  const [width, setWidth] = useState(0);
  const [element, setElement] = useState(null);
  const ref = useCallback((node) => {
    setElement(node);
    if (node) {
      setWidth(node.getBoundingClientRect().width);
    }
  }, []);
  useResizeObserver(element, ({ contentRect }) => {
    if (contentRect.width > 0) {
      setWidth(contentRect.width);
    }
  });
  return [ref, width];
};
export default useNaturalWidth;
